import { Switch as RadixSwitch } from 'radix-ui';
import type { ComponentPropsWithoutRef } from 'react';
import * as styles from './index.css';

export type SwitchProps = ComponentPropsWithoutRef<typeof RadixSwitch.Root>;

export function Switch(props: SwitchProps) {
    return (
        <RadixSwitch.Root className={styles.root} {...props}>
            <RadixSwitch.Thumb className={styles.thumb} />
        </RadixSwitch.Root>
    );
}
